export type OrderCmdType = 'standard' | 'physical' | 'virtual'

export type DotationNature = 'urssaf' | 'classic'

export type DistributionMode = 'single' | 'csv'

export type CardFunding = 'beneficiary' | 'organization'

export interface DotationOrderForm {
  cmdType: OrderCmdType
  nature: DotationNature | ''
  ursafEventId: string
  ursafEventName: string
  enableBankCard: boolean
  cardFunding: CardFunding | ''
  organizationIssuanceSubsidyPercent: number
  organizationLoadingSubsidyPercent: number
  programId: string
  distributionMode: DistributionMode | ''
  customerId: string
  customerLabel: string
  amount: string
  scheduledAt: string
  customerClientReference: string
  csvBlob: string
  csvFileName: string
  csvHasErrors: boolean
}

export interface OrderResultFail {
  rowNumber: number
  message: string
}

export interface OrderResult {
  reference: string
  totalAmount: number
  successCount: number
  failsCount: number
  fails: OrderResultFail[]
}

export function createEmptyDotationOrderForm(): DotationOrderForm {
  return {
    cmdType: 'standard',
    nature: '',
    ursafEventId: '',
    ursafEventName: '',
    enableBankCard: false,
    cardFunding: '',
    organizationIssuanceSubsidyPercent: 100,
    organizationLoadingSubsidyPercent: 100,
    programId: '',
    distributionMode: '',
    customerId: '',
    customerLabel: '',
    amount: '',
    scheduledAt: '',
    customerClientReference: '',
    csvBlob: '',
    csvFileName: '',
    csvHasErrors: false
  }
}

export const CSV_HEADERS = [
  'firstname',
  'lastname',
  'gender',
  'email',
  'amount',
  'customer_client_reference'
] as const
